export default __webpack_public_path__ + "static/media/complaint.ac5e89d7.svg";